module.exports = __webpack_public_path__ + "static/media/module_badge_parenting_and_substance_use.bf6cc10b.png";